// extracted by mini-css-extract-plugin
export default {"forgotPasswordForm":"forgotPasswordForm_forgotPasswordForm__TbHR4","nameWrapper":"forgotPasswordForm_nameWrapper__+b+0K","extraWrapper":"forgotPasswordForm_extraWrapper__ekS7q"};